import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import getRoutesConfig from './Shared/Utils/routesConfig';
import GlobalLoader from './Shared/Components/Loader/GlobalLoader';
import './Shared/Styles/Common.css';
import { Provider, useDispatch } from 'react-redux';
import { store, persistor } from './Redux/Store';
import { PersistGate } from 'redux-persist/integration/react';
import { clearAllLoaders } from './Shared/Slice/LoaderSlice';
import AutoLogout from './Shared/Components/Autologout/AutoLogout';
import { userlogout, acquireLogoutLock } from './Shared/Slice/AuthSlice';

function AppContent() {
  const dispatch = useDispatch();
  const routesConfig = getRoutesConfig();

  // Clean up any stuck loaders on app initialization
  useEffect(() => {
    const cleanupLoaders = () => {
      // Clear all loaders at once
      dispatch(clearAllLoaders());
    };

    // Clean up loaders after a short delay to ensure app is fully loaded
    const timeoutId = setTimeout(cleanupLoaders, 1000);

    return () => clearTimeout(timeoutId);
  }, [dispatch]);
  const handleLogout = () => {
    if (!acquireLogoutLock()) return;
    dispatch(userlogout());
    window.location.href = '/';
  };

  return (
    <>
      <AutoLogout logout={handleLogout} />
      <GlobalLoader />
      <RouterProvider router={routesConfig} />
      <ToastContainer />
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppContent />
      </PersistGate>
    </Provider>
  );
}

export default App;
